export const removeRouteNameLanguageSuffix = (routeName) => {
  if (routeName === null) {
    return null
  }

  const index = routeName.indexOf('___')

  return index === -1 ? routeName : routeName.substring(0, index) // No '___' found, return the original route
}
